<div
	fxLayout="column"
	class="sdp-app-container app-content"
>
	<header
		fxFlex="64px"
		fxFlex.sm="48px"
		fxFlex.xs="48px"
	>
		<sdp-header></sdp-header>
	</header>
	<div
		id="sdp-main"
		[className]="isUserRefreshing() ? 'sdp-hidden' : ''"
		fxFlex
	>
		<router-outlet></router-outlet>
	</div>
	<div
		id="loader-wrapper"
		[className]="isUserRefreshing() ? 'loader-user-refreshing' : 'sdp-hidden'"
	>
		<div id="loader"></div>
		<div class="loader-section section-left"></div>
		<div class="loader-section section-right"></div>
	</div>
</div>
<footer class="sdp-app-footer">
	<sdp-translate
		display="dropdown"
		class="sdp-app-translate"
	></sdp-translate>
	<sdp-footer></sdp-footer>
</footer>